<template>
    <div class="mine-apply">
        <div class="banner">
            <div class="title">申请成为设计师</div>
        </div>

        <div class="screening">
            <input v-model="applyForm.remarks" class="item-input" placeholder="我是XXX" type="text" />
            <van-button class="item-button" color="#6b4d9a" round size="mini" @click="apply()">申请</van-button>
        </div>
    </div>
</template>

<script>
import { APPLY } from "@/api/dataProvider.js";
import { setCookie } from "@/utils/storage";

export default {
    name: "MineApply",
    data() {
        return {
            applyForm: {
                remarks: ""
            }
        };
    },
    mounted() {},
    methods: {
        apply() {
            let that = this;
            if (!that.applyForm.remarks) {
                that.$notify({ type: "danger", message: "请输入申请内容！" });
                return false;
            }
            APPLY(
                {
                    remarks: that.applyForm.remarks
                },
                function(res) {
                    console.log(res);
                    if (res.data.code == 0) {
                        that.$notify({
                            type: "success",
                            message: "已提交申请",
                            onClose() {
                                that.$router.push({ name: "Home" });
                            }
                        });
                    } else {
                        that.$notify({ type: "danger", message: "已提交，请勿重复申请" });
                    }
                }
            );
        }
    }
};
</script>

<style scoped lang="scss">
.mine-apply {
    .banner {
        width: 100%;
        height: 156px;
        padding: 27px 0 0 0;
        background: url("../../assets/img/login/bg.png") no-repeat;
        background-size: cover;
        background-position: center;
        .title {
            margin: 50px 0 10px;
            text-align: center;
            color: #fff;
            font-size: 20px;
            font-weight: bold;
        }
    }

    .screening {
        margin: 27px 0 0 0;
        padding: 0 17px;
        text-align: center;

        .item-input {
            vertical-align: middle;
            width: 200px;
            line-height: 24px;
            border: 5px solid #f8f8f8;
            border-radius: 15px;
            text-align: center;
            font-size: 12px;
            color: #333;
        }
        .item-button {
            padding: 0 15px;
            vertical-align: middle;
            margin-left: 10px;
        }
    }
}
</style>
